module.exports = __webpack_public_path__ + "static/media/chat_extraction.49889a11.svg";